import { render, staticRenderFns } from "./DocumentAssociationRemovalDrawer.vue?vue&type=template&id=55c46bda&scoped=true&"
import script from "./DocumentAssociationRemovalDrawer.vue?vue&type=script&lang=ts&"
export * from "./DocumentAssociationRemovalDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentAssociationRemovalDrawer.vue?vue&type=style&index=0&id=55c46bda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c46bda",
  null
  
)

export default component.exports